import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandHandclapIcon} from "@pg-design/icons-module";
import {Link} from "@pg-design/link-module";
import {Modal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {kmAppLink} from "@pg-mono/km-routes";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {useKMLink} from "../../../hooks/use_km_link";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
}

export const PromotionLeadSuccess = (props: IProps) => {
    const {isOpen, onClose} = props;

    const kmBaseLink = useKMLink(kmAppLink.site.baseWithParams);

    return (
        <Modal isOpen={isOpen} onModalClose={onClose}>
            <Modal.Layout.EmptyResponsive
                closeButtonVariant="rounded"
                className={modalStyle}
                dataTestId={OFFER_TEST_IDS.LEAD_FORM.PROMOTION_LEAD_SUCCESS_MODAL}
            >
                <div className={contentStyle}>
                    <BrandHandclapIcon size="19" wrapperSize="19" wrapperColor="var(--colors-primary)" />

                    <Text variant="headline_2" align="center" className={titleStyle}>
                        Twoje zapytanie zostało wysłane
                    </Text>

                    <Text variant="body_copy_2" align="center" className={descriptionStyle}>
                        Możesz też już korzystać ze swojego{" "}
                        <Link size="big" href={kmBaseLink} className={linkStyle}>
                            konta mieszkaniowego.
                        </Link>{" "}
                        Od tej chwili wszystkie ceny na portalu są odkryte.
                    </Text>

                    <Button
                        variant="filled_primary"
                        onClick={onClose}
                        className={buttonStyle}
                        dataTestId={OFFER_TEST_IDS.LEAD_FORM.PROMOTION_LEAD_SUCCESS_CLOSE_BUTTON}
                    >
                        Powróć
                    </Button>
                </div>
            </Modal.Layout.EmptyResponsive>
        </Modal>
    );
};

const modalStyle = css({
    maxWidth: "560px",
    p: 3,
    md: {
        p: 4
    }
});

const contentStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 3,
    py: 6,
    md: {
        py: 8
    }
});

const titleStyle = css({
    maxWidth: "60rem"
});

const descriptionStyle = css({
    maxWidth: "56rem"
});

const linkStyle = css({
    color: "var(--colors-gray-800)",
    textDecoration: "underline"
});

const buttonStyle = css({
    mt: 2,
    width: "100%",
    minWidth: "18rem",
    md: {
        width: "auto"
    }
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {BrandHandclapIcon} from "@pg-design/icons-module";
import {Link} from "@pg-design/link-module";
import {Modal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {kmAppLink} from "@pg-mono/km-routes";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {useKMLink} from "../../../hooks/use_km_link";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
}

export const PromotionLeadSuccess = (props: IProps) => {
    const {isOpen, onClose} = props;

    const kmBaseLink = useKMLink(kmAppLink.site.baseWithParams);

    return (
        <Modal isOpen={isOpen} onModalClose={onClose}>
            <Modal.Layout.EmptyResponsive
                closeButtonVariant="rounded"
                className={modalStyle}
                dataTestId={OFFER_TEST_IDS.LEAD_FORM.PROMOTION_LEAD_SUCCESS_MODAL}
            >
                <div className={contentStyle}>
                    <BrandHandclapIcon size="19" wrapperSize="19" wrapperColor="var(--colors-primary)" />

                    <Text variant="headline_2" align="center" className={titleStyle}>
                        Twoje zapytanie zostało wysłane
                    </Text>

                    <Text variant="body_copy_2" align="center" className={descriptionStyle}>
                        Możesz też już korzystać ze swojego{" "}
                        <Link size="big" href={kmBaseLink} className={linkStyle}>
                            konta mieszkaniowego.
                        </Link>{" "}
                        Od tej chwili wszystkie ceny na portalu są odkryte.
                    </Text>

                    <Button
                        variant="filled_primary"
                        onClick={onClose}
                        className={buttonStyle}
                        dataTestId={OFFER_TEST_IDS.LEAD_FORM.PROMOTION_LEAD_SUCCESS_CLOSE_BUTTON}
                    >
                        Powróć
                    </Button>
                </div>
            </Modal.Layout.EmptyResponsive>
        </Modal>
    );
};

const modalStyle = css({
    maxWidth: "560px",
    p: 3,
    md: {
        p: 4
    }
});

const contentStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 3,
    py: 6,
    md: {
        py: 8
    }
});

const titleStyle = css({
    maxWidth: "60rem"
});

const descriptionStyle = css({
    maxWidth: "56rem"
});

const linkStyle = css({
    color: "var(--colors-gray-800)",
    textDecoration: "underline"
});

const buttonStyle = css({
    mt: 2,
    width: "100%",
    minWidth: "18rem",
    md: {
        width: "auto"
    }
});
